import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';


export const createProfileAction = {
    createProfileHandler,
    isSignUpCompleted,
};

function createProfileHandler(data) {


    return dispatch => {
        dispatch(request());
        userProfileService.createProfileHandler(data)
            .then(
                createProfile => {
                    window.location.reload();

                    dispatch(createProfileAction.isSignUpCompleted('true'))

                    dispatch(success(createProfile));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_CREATE_PROFILE } }
    function success(createProfile) { return { type: userProfileConstants.RECEIVE_CREATE_PROFILE, createProfile } }
    function failure(error) { return { type: userProfileConstants.CREATE_PROFILE_ERROR, error } }
}

function isSignUpCompleted(data) {
    return dispatch => {
        dispatch(request());
        dispatch(success(data));
    }
    function request() { return { type: userProfileConstants.REQUEST_SIGNUP_COMPLETED } }
    function success(data) { return { type: userProfileConstants.RECEIVE_SIGNUP_COMPLETED, data } }

}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/createProfile.action.js